import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import './Locations.scss'

const Locations = ({ sites, formData }) => {
  const addressFormatter = (site) => {
    let address = [];
    if (site?.location_data?.source?.facility?.name) {
      address.push(`${site?.location_data?.source?.facility?.name}`);
    }
    if (site?.location_data?.source?.facility?.address) {
      let { city, state, country, zip } = site.location_data.source.facility.address;
      address = [...address, city, state, country, zip].filter(item => item && item.toString().length > 0).join(", ").trim();
    }
    return address;
  }

  const displayLocation = (site) => {
    let address = "";
    if (site?.location_data?.source?.facility?.address) {
      let { state, country } = site.location_data.source.facility.address;
      address = [country, state].filter(item => item && item.toString().length > 0).join(", ").trim();
    }
    return address;
  }

  const displayInvestivators = (site) => {
    let display = null;
    let investigators = site?.location_data?.source?.investigator || []
    if (investigators) {
      if (!Array.isArray(investigators)) investigators = [investigators];
      let subInvestigator = [];
      let priInvestigator = [];
      investigators?.forEach(investigator => {
        if (investigator?.role?.includes("Sub") || investigator?.role?.includes("sub")) {
          subInvestigator.push(investigator);
        } else if (investigator?.role?.includes("Principal") || investigator?.role?.includes("principal")) {
          priInvestigator.push(investigator);
        }
      });

      display = (
        <div className="investigator-container">
          {priInvestigator.length > 0 &&
            <div>
              <div className="investigator-title">
                Principal div
              </div>
              <div style={{ paddingLeft: 16 }}>
                {priInvestigator.map(item => {
                  return (
                    <div key={uuidv4()}>
                      {formatContact(item)}
                    </div>
                  )
                })}
              </div>
            </div>
          }

          {subInvestigator.length > 0 &&
            <div>
              <div>
                Sub-principal div
              </div>
              <div style={{ paddingLeft: 16 }}>
                {subInvestigator.map(item => {
                  return (
                    <div key={uuidv4()}>
                      {formatContact(item)}
                    </div>
                  )
                })}
              </div>
            </div>
          }
        </div>
      )
    }

    return display;
  }

  const formatContact = ({
    first_name = "",
    middle_name = "",
    last_name = "",
    degrees = "",
  }) => {
    let fullName = [first_name, middle_name, last_name].filter(item => item && item.length > 0).join(" ").trim();
    let fullNameDegree = [fullName, degrees].filter(item => item && item.length > 0).join(", ").trim();

    return fullNameDegree;
  }

  const displayContacts = (site) => {
    const formatContact = (props) => {
      let fullName = [props?.first_name, props?.middle_name, props?.last_name].filter(item => item && item.length > 0).join(" ").trim();
      let fullNameDegree = [fullName, props?.degrees].filter(item => item && item.length > 0).join(", ").trim();
      let phoneNumber = [props?.phone, props?.phone_ext].filter(item => item && item.toString().length > 0).join(" ext: ").trim();
      let str = [fullNameDegree, phoneNumber, props?.email].filter(str => str && str.length > 0).join("\n");
      return str;
    }

    let primaryContact = formatContact(site?.location_data?.source?.contact);
    let backupContact = formatContact(site?.location_data?.source?.contact_backup);

    return (
      <>
        {primaryContact && primaryContact.length > 0 &&
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontWeight: "bold" }}>Primary Contact</div>
            {primaryContact}
          </div>
        }
        {backupContact && backupContact.length > 0 &&
          <div>
            <div style={{ fontWeight: "bold" }}>Backup Site Contact</div>
            {backupContact}
          </div>
        }
      </>
    )
  }

  if (!sites || sites?.length === 0) return null;

  return (
    <div className="page-preview-locations-container">
      <div className="locations-title">
        Locations
      </div>
      {sites?.map((site, index) => {
        return (
          <div key={uuidv4()}>
            <div className="location-container">
              {index + 1}. {displayLocation(site)}
            </div>
            <div className="facility-container">
              {site?.location_data?.source?.facility?.facility_name}
            </div>
            <div className="address-contact-container">
              <div>
                {addressFormatter(site)}
              </div>
              {formData?.protocol?.study_timeline?.recruitment?.recruitment_status === "Recruiting" && (
                <div className="address-container">
                  <span>
                    Recruitment Status:&nbsp;
                  </span>
                  {site?.location_data?.source?.status || "-"}
                </div>
              )}
              {displayContacts(site)}
            </div>
            {displayInvestivators(site)}
          </div>
        )
      })}
    </div>
  );
};

export default Locations;